import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { CopyButton } from './copy-button';
import styles from './coupon-field.module.scss';
export const CouponField = ({ couponCode })=>/*#__PURE__*/ _jsxs("div", {
        className: styles.field,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                children: couponCode
            }),
            /*#__PURE__*/ _jsx(CopyButton, {
                text: couponCode
            })
        ]
    });

//# sourceMappingURL=coupon-field.js.map